import React from "react";
import { Navigate, useParams } from "react-router-dom";

/** Legacy /targeting/:templateId → /recipes/:templateId. <Navigate> cannot forward path params on its own. */
const RedirectToRecipe = () => {
  const { templateId } = useParams();

  return <Navigate to={`/recipes/${templateId}`} replace />;
};

export default RedirectToRecipe;
